/* eslint-disable fp/no-loops */
import { CellSelection } from '@tiptap/pm/tables';
import { Decoration } from '@tiptap/pm/view';
import { getCellsInRow } from 'prosemirror-utils';

import { TableQuery } from '../TableQuery';
import styles from './controllers-scss';
import { dragAndDropSvg } from './svgs';

export const rowHandlerDecoration = (state: $TSFixMe, editor: $TSFixMe, key: $TSFixMe) => {
  const decorations: Decoration[] = [];
  const { selection } = state;
  const table = TableQuery.of(selection);

  const isAllCellsSelected = table.isTableSelected();
  const tableMap = table.map;

  for (let i = 0; i < tableMap.height; i += 1) {
    const div = document.createElement('div');
    div.classList.add(styles.rowController);
    div.dataset.hook = `rowDrag-${i}`;
    div.addEventListener('mousedown', e => handleRowControllerMouseDown(i, e, editor, table, key));
    div.innerHTML = dragAndDropSvg;

    const resizerDiv = document.createElement('div');
    resizerDiv.classList.add(styles.rowResize);

    if (isAllCellsSelected) {
      div.classList.add(styles.allCellsSelected);
    } else if (table.isRowSelected(i)) {
      div.classList.add(styles.selected);
    }
    if (i === tableMap.height - 1) {
      div.classList.add(styles.last);
    }
    decorations.push(
      Decoration.widget(table.getStartPos() + tableMap.map[i * tableMap.width] + 1, div)
    );
    decorations.push(
      Decoration.widget(table.getStartPos() + tableMap.map[i * tableMap.width] + 1, resizerDiv)
    );
  }

  return decorations;
};

function handleRowControllerMouseDown(
  i: number,
  event: MouseEvent,
  editor: $TSFixMe,
  table: TableQuery,
  key: $TSFixMe
) {
  event.stopPropagation();
  event.preventDefault();
  const { selection, doc, tr } = editor.state;
  if (!table.isRowSelected(i)) {
    if (selection.isRowSelection?.() && event.shiftKey) {
      // Adding to an existing rows selection
      const { $anchorCell, $headCell } = selection;
      const $head = $anchorCell.pos > $headCell.pos ? $headCell : $anchorCell;

      if (!$head) {
        return;
      }
      const $anchor = doc.resolve(getCellsInRow(i)(selection)?.[table.getWidth() - 1].pos);

      const rowsSelection = new CellSelection($anchor, $head);
      if (!selection.eq(rowsSelection)) {
        editor.view.dispatch(tr.setSelection(rowsSelection));
      }
    } else {
      editor.commands.selectRowAtIndex(i);
    }
  }
  const rowsSelection = editor.state.selection;

  const updatedTable = TableQuery.of(editor.state.selection);
  const selectedRows = updatedTable.getRowsIndexesInSelection();
  const rowsHeight = updatedTable.getRowsHeight(editor.view);
  const startTop = rowsHeight.slice(0, selectedRows[0]).reduce((curr, height) => curr + height, 0);

  const startY = event.clientY;
  const totalHeight = rowsHeight.reduce((curr, height) => curr + height, 0);
  const dragPreviewHeight = selectedRows.reduce((curr, rowIndex) => curr + rowsHeight[rowIndex], 0);
  let dropIndex = -1;

  function move(event: $TSFixMe) {
    const dragging = event.clientY;
    const top = Math.min(startTop + dragging - startY, totalHeight - dragPreviewHeight + 20);
    if (event.movementY !== 0) {
      dropIndex = calculateRowDropIndex(event, rowsHeight, top, dragPreviewHeight);
      editor.view.dispatch(
        tr.setMeta(key, {
          rowDraggingState: { dragging: true, dropIndex, top, dragPreviewHeight },
        })
      );
    }
    //TODO: check why the selection changed after dispatch tr.setMeta with dragging state
    if (editor.state.selection !== rowsSelection) {
      editor.view.dispatch(tr.setSelection(rowsSelection));
    }
  }
  function finish() {
    if (dropIndex > -1) {
      editor.view.dispatch(tr.setMeta(key, { rowDraggingState: { dragging: false } }));
      if (dropIndex !== i) {
        editor.commands.reorderRows(
          { start: selectedRows[0], end: selectedRows[selectedRows.length - 1] },
          dropIndex
        );
      }
    }

    window.removeEventListener('mouseup', finish);
    window.removeEventListener('mousemove', move);
  }

  window.addEventListener('mouseup', finish);
  window.addEventListener('mousemove', move);
}

function calculateRowDropIndex(
  event: MouseEvent,
  rowsHeight: number[],
  top: number,
  previewHeight: number
): number {
  let dropIndex = 0;
  rowsHeight.forEach((_, index) => {
    const prevTotalHeight = rowsHeight.slice(0, index).reduce((curr, height) => curr + height, 0);
    if (
      (event.movementY > 0 && top + previewHeight > prevTotalHeight - 19) ||
      (event.movementY < 0 && top > prevTotalHeight - previewHeight / 2)
    ) {
      dropIndex = index;
    }
  });
  return dropIndex;
}
